export default __webpack_public_path__ + "static/media/coin_3.d4440081.png";